import { render, staticRenderFns } from "./reports-avg-talktime-column-graph.vue?vue&type=template&id=604d76c6"
import script from "./reports-avg-talktime-column-graph.vue?vue&type=script&lang=js"
export * from "./reports-avg-talktime-column-graph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports